import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 32,
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: theme.spacing(1),
  },
  subtitle: {
    fontSize: 14,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(3),
  },
  methodToggle: {
    display: 'flex',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
  selectedToggle: {
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText,
    },
  },
  unselectedToggle: {
    '&:hover': {
      backgroundColor: 'transparent',
      opacity: 0.7,
    },
  },
  field: {
    marginBottom: theme.spacing(2),
  },
  submitButton: {
    marginTop: theme.spacing(1),
    height: 48,
    fontWeight: 600,
    letterSpacing: 1,
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText,
    },
  },
}))

export default useStyles
